<div class="modal-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <article class="modal-content">
        <header class="modal-header">
            <h2>Manual Status</h2>
            <div class="bar"></div>

            <button class="close-wrapper" (click)="close(undefined)" aria-label="Close modal">
                <div class="icon" [innerHTML]="closeIcon"></div>
            </button>
        </header>
        <section class="modal-body">
            <div class="form-group">
                <label for="status" class="label">
                    <span class="label-title">Status</span>
                    <span class="label-subtitle">Required</span>
                </label>
                <div class="form-inputs">
                    <lib-generic-dropdown
                        [source]="opportunityStatus ? opportunityStatus : []"
                        [selectedItem]="opportunityData.opportunityStatus"
                        (selectedItemChange)="manualStatusChange($event)"
                        [placeholder]="'No date selected'"
                        [config]="{ defaultText: 'No date selected', itemDisplayKey: 'name' }"
                        class="form-input"
                    >
                    </lib-generic-dropdown>
                </div>
            </div>
            @if (opportunityData.opportunityStatus?.id && opportunityData.opportunityStatus?.id !== 1) {
                <div class="form-group">
                    <label for="actualValue" class="label">
                        <span class="label-title">Actual Value ($)</span>
                        <span class="label-subtitle">Required</span>
                    </label>
                    <div class="form-inputs">
                        <input
                            libInputFormatter="C2"
                            class="form-input"
                            type="text"
                            name="actualValue"
                            [(ngModel)]="opportunityData.actualValue"
                            (ngModelChange)="onActualValueEdited($event)"
                            placeholder="Add Actual Value"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                        />
                        @if (errorActualValue) {
                            <p class="errorMessage">{{ errorActualValue }}</p>
                        }
                    </div>
                </div>
            }
            @if (opportunityData.opportunityStatus?.id && opportunityData.opportunityStatus?.id !== 1) {
                <div class="form-group">
                    <label for="actualGrossMargin" class="label">
                        <span class="label-title">Actual GM (%)</span>
                        <span class="label-subtitle">Required</span>
                    </label>
                    <div class="form-inputs">
                        <input
                            class="form-input"
                            type="text"
                            name="actualGrossMargin"
                            libInputFormatter="N2"
                            suffix="%"
                            [(ngModel)]="actualGrossMargin"
                            (ngModelChange)="onGrossMarginChange($event)"
                            placeholder="Add Actual GM"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                        />
                    </div>
                </div>
            }
        </section>

        <footer class="modal-footer">
            <button class="modal-button cancel" (click)="close(undefined)" [disabled]="isLoading">Cancel</button>
            <app-loading-button
                [isLoading]="isLoading"
                [disabled]="disabled"
                (clickEvent)="onConfirm()"
                [text]="'Apply'"
            ></app-loading-button>
        </footer>
    </article>
</div>

<ng-template #templatesItemTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="data.object?.name ?? ''"
        [subtitle]="data.object?.description ?? ''"
    >
    </app-custom-menu-item>
</ng-template>
